export const ROL_BASE_OBJ = {
  info: { nombre: '' },
  modulos: { 
    propietarios: {
      accesos: false, 
      informacion: {
        consultar: false,
        crear: false,
        editar: false,
        eliminar: false
      },
      saldo_tickets: {
        consultar: false,
        crear: false,
        editar: false,
        eliminar: false
      }  
    },
    pacientes: { 
      accesos: false, 
      informacion: {
        consultar: false,
        crear: false,
        editar: false,
        eliminar: false
      },
      casos: {
        consultar: false,
        crear: false,
        editar: false,
        eliminar: false
      },
      productos_servicios: {
        consultar: false,
        crear: false,
        editar: false,
        eliminar: false
      },
      plan_bienestar: {
        consultar: false,
        crear: false,
        editar: false,
        eliminar: false
      }
    },
    casos: {
      accesos: false, 
      casos: {
        consultar: false,
        crear: false,
        editar: false,
        eliminar: false
      },
      productos_servicios: {
        consultar: false,
        crear: false,
        editar: false,
        eliminar: false
      }  
    },
    agenda: {
      accesos: false, 
      citas: {
        consultar: false,
        crear: false,
        editar: false,
        eliminar: false
      },
      configuracion: {
        consultar: false,
        crear: false,
        editar: false,
        eliminar: false
      } 
    },
    sala_espera: {
      accesos: false, 
      informacion: {
        consultar: false,
        crear: false,
        editar: false,
        eliminar: false
      } 
    },
    planes_bienestar: {
      accesos: false, 
      planes_bienestar: {
        consultar: false,
        crear: false,
        editar: false,
        eliminar: false
      } 
    },
    cortes_caja: {
      accesos: false, 
      caja: {
        consultar: false,
        crear: false,
        editar: false,
        eliminar: false
      } 
    },
    descuentos: {
      accesos: false, 
      descuentos: {
        consultar: false,
        crear: false,
        editar: false,
        eliminar: false
      } 
    },
    corporativo: {
      accesos: false, 
      corporativo: {
        consultar: false,
        crear: false,
        editar: false,
        eliminar: false
      },
      franquicias: {
        consultar: false,
        crear: false,
        editar: false,
        eliminar: false
      },
      sucursales: {
        consultar: false,
        crear: false,
        editar: false,
        eliminar: false
      } 
    },
    usuarios: {
      accesos: false, 
      informacion: {
        consultar: false,
        crear: false,
        editar: false,
        eliminar: false
      }
    },
    roles: {
      accesos: false, 
      informacion: {
        consultar: false,
        crear: false,
        editar: false,
        eliminar: false
      }
    },
    vencimientos: {
      accesos: false, 
      informacion: {
        consultar: false,
        crear: false,
        editar: false,
        eliminar: false
      }
    },
    reportes: {
      accesos: false, 
      reportes: {
        consultar: false,
        crear: false,
        editar: false,
        eliminar: false
      }
    },
    catalogos: {
      accesos: false, 
      catalogos: {
        consultar: false,
        crear: false,
        editar: false,
        eliminar: false
      }
    },


    ventas_mostrador: {
      accesos: true, 
      ventas_mostrador: {
        consultar: true,
        crear: true,
        editar: true,
        eliminar: true
      }
    },

    proveedores: {
      accesos: true, 
      proveedores: {
        consultar: true,
        crear: true,
        editar: true,
        eliminar: true
      }
    },

    compras: {
      accesos: true, 
      compras: {
        consultar: true,
        crear: true,
        editar: true,
        eliminar: true
      }
    },

    inventarios: {
      accesos: true, 
      inventarios: {
        consultar: true,
        crear: true,
        editar: true,
        eliminar: true
      }
    },


    
    autorizacion: {
      accesos: false, 
      informacion: {
        consultar: false,
        crear: false,
        editar: false,
        eliminar: false
      } 
    },
  }
}



// WEBPACK FOOTER //
// ./src/constantes/roles.js